///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard = abcsetup.dashboard || {};
abcsetup.dashboard.sgs_team = abcsetup.dashboard.sgs_team || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.dashboard.sgs_team = {
    selected_opportunity: null,

    init: function() {

        // Opportunity type toggle
        $('#opportunity-type-toggle .btn').on('click', function(){
            $(this).siblings().removeClass('active');

            var selected = $(this).val();
            var sections = [
                'sourcing-reviews',
                'pricing-reviews',
                'sgs-pricing-reviews',
                'sgs-counteroffer-reviews',
                'sgs-counteroffer-reviews2'
            ];

            for (var i in sections) {
                var container = $('#'+sections[i]);

                switch (selected) {
                    case 'solicited':
                        container.find('.count').text(container.find('.opportunity.solicited').length);
                        container.find('.opportunity.solicited').show();
                        container.find('.opportunity.unsolicited').hide();
                        $('#open-opportunities-section').removeClass('not-available');
                        break;
                    case 'unsolicited':
                        container.find('.count').text(container.find('.opportunity.unsolicited').length);
                        container.find('.opportunity.unsolicited').show();
                        container.find('.opportunity.solicited').hide();
                        $('#open-opportunities-section').addClass('not-available');
                        break;
                    default:
                        container.find('.count').text(container.find('.opportunity').length);
                        container.find('.opportunity').show();
                        $('#open-opportunities-section').removeClass('not-available');
                }
            }

        });

        // Init popovers
        $('.opportunity-actions').popover({
            container: 'body',
            html: true,
            placement: 'top',

            template: ''+
                '<div class="popover popover-sgs" role="tooltip">'+
                    '<div class="popover-body"></div>'+
                '</div>',
            content: function(){
                abcsetup.dashboard.sgs_team.selected_opportunity = $(this).data('id');
                return ''+
                    '<a class="opportunity-edit"><i class="fas fa-edit"></i> Edit</a>'+
                    '<a class="opportunity-delete" id="' + abcsetup.dashboard.sgs_team.selected_opportunity + '"><i class="fas fa-trash"></i> Delete</a>'
                ;
            }
        });

        // Edit opportunity button
        $(document).on('click', '.opportunity-edit', e => {
            $('.opportunity-actions').popover('hide');
            $('#short-dated-opportunity-modal').modal('show');

            var id = abcsetup.dashboard.sgs_team.selected_opportunity;
            var name = $('#opportunity-'+id+' .name').text();
            var start_date = $('#opportunity-'+id+' .start_date').text();
            var end_date = $('#opportunity-'+id+' .end_date').text();
            var paused = $('#opportunity-'+id+'-paused').val();

            $('#edit_id').val(id);
            $('#edit_name').val(name);
            $('#edit_start_date').val(start_date);
            $('#edit_end_date').val(end_date);
            $('#edit_paused').prop('checked', false);
            $('#paused_date_container').addClass('hide');

            if (paused !== null && paused !== '') {
                $('#edit_paused').prop('checked', true);
                $('#paused_date_container').removeClass('hide');
                $('#paused_date').text(paused);
            }
        });

        // Delete opportunity button
        $(document).on('click', '.opportunity-delete', e => {
            $('.opportunity-actions').popover('hide');
            var id = $('.opportunity-delete').attr('id');
            abcsetup.alerts.confirm('Delete Opportunity',
            '<div class="alert alert-info">Please enter a reason for deleting the opportunity</div><label>Delete Reason:</label><input id="delete-reason" type="text" class="form-control" name="delete-reason" value="" required>', function (resp) {
                if (resp) {
                    var delete_reason = $('#delete-reason').val();
                    abcsetup.dashboard.sgs_team.delete(id, delete_reason);
                    setTimeout(() => {
                        abcsetup.alerts.flashMessage('The opportunity has been deleted', 'success');
                    }, 750);
                }
            });
        });

        // Short Opportuniy form submission
        $('#short-dated-opportunity-form').on('submit', e => {
            e.preventDefault();

            var request = {
                id: $('#edit_id').val(),
                name: $('#edit_name').val(),
                start_date: $('#edit_start_date').val(),
                end_date: $('#edit_end_date').val(),
                paused: ($('#edit_paused').prop('checked')) ? 'y' : 'n',
            };

            axios.post('/api/short_dated_opportunity/edit', request).then(response => {
                if (response.data.message_type === 'success') {
                    abcsetup.alerts.show('Success', response.data.message_text);
                    $('#opportunity-'+response.data.id+' .name').text(response.data.name);
                    $('#opportunity-'+response.data.id+' .start_date').text(response.data.start_date);
                    $('#opportunity-'+response.data.id+' .end_date').text(response.data.end_date);
                    $('#opportunity-'+response.data.id+'-paused').val(response.data.paused);

                    // Adjust icon
                    if (response.data.paused === null) {
                        $('#opportunity-'+response.data.id+' .play-pause-icon').removeClass('fa-pause-circle').addClass('fa-play-circle');
                    } else {
                        $('#opportunity-'+response.data.id+' .play-pause-icon').removeClass('fa-play-circle').addClass('fa-pause-circle');
                    }

                    $('#short-dated-opportunity-modal').modal('hide');
                } else {
                    abcsetup.alerts.show('Error', response.data.message_text);
                }
            });

            return;
        });
    },

    delete: function(id, delete_reason) {
        abcsetup.blockUI(true);
        axios.delete('/api/short_dated_opportunity/delete/' + id, {data: {delete_reason: delete_reason}}).then(response => {
            abcsetup.unblockUI();
            location.reload();
        });
    },

    // Add an opportunity to the DOM
    addOpportunityToDOM: function(opportunity) {
        var html = `
            <div class="opportunity"></div>
        `;
    }
}